
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/mui-next-js-app-router",
      function () {
        return require("private-next-pages/blog/mui-next-js-app-router.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/mui-next-js-app-router"])
      });
    }
  